const FilterWrapper = (props: { label: string, children: any, flex?: boolean, className?: string, hint?: string }) => {
  return (
    <div className={`py-2 w-full ${ props.className }`}>
      <h3 className="pb-1">
        { props.label }
        { props.hint && <span className="text-xs italic opacity-60 pl-2">{ props.hint }</span> }
      </h3>
      <div className={`${!props.flex || "flex space-x-4 items-center"} w-full`}>
        { props.children }
      </div>
    </div>
  )
}

export default FilterWrapper;